import { useParams as useParamsBase } from 'react-router-dom';
/**
 * React Router の useParams をラップしたカスタムフック
 * https://reactrouter.com/en/6.22.1/hooks/use-params
 */
export const useParams = useParamsBase;
